// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.min-height-vh-triggered {
  min-height: 800px;
  max-height: calc(100vh - 110px);
  height: calc(100vh - 110px);
}

.table_list {
  transition: 0.3s;
}

.registered_slider {
  letter-spacing: 0.2px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.table-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}

.table-responsive {
  overflow-x: auto;
  width: 100%;
}

.table {
  margin-bottom: 0;
}

.table th {
  padding: 0.5rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
  padding: 0.5rem;
}

.table td mat-checkbox label {
  margin: 0 !important;
}

tr.mat-mdc-row {
  cursor: pointer;
}

tr.mat-mdc-row.highlighted {
  background-color: rgba(159, 170, 229, 0.5);
  margin: 0 -15px;
  border-radius: 3px;
}

.status-info-container {
  text-shadow: 2px 2px 5px #b5b5b5;
}

.status-cell {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.status-content {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.status-text {
  line-height: 1;
}

.info-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  cursor: pointer;
}

.excelButton button[mat-raised-button]:hover {
  background-color: #408f64 !important;
  transition: background-color 0.3s ease;
}

.delete-btn-color {
  color: #A72925;
}

.chips-container {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.custom-chip {
  position: relative;
  background-color: #f5f5f5 !important;
  border-radius: 4px !important;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}
.custom-chip::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0%;
  height: 2px;
  background-color: #3f51b5;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}
.custom-chip:hover::after {
  width: 99%;
}
.custom-chip.mdc-evolution-chip--selected {
  background-color: #3f51b5 !important;
  color: white !important;
}

.age-pill {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 30px;
  padding: 6px 14px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  transition: background 0.2s ease;
  margin-bottom: 18px;
  transform: translateY(2px);
  margin-right: 1rem;
}

.age-pill:hover {
  background: rgba(0, 0, 0, 0.08);
}

.age-pill-input {
  width: 50px;
  border: none;
  outline: none;
  background: transparent;
  text-align: center;
  font-size: 14px;
}

/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version.*/
mat-chip-listbox {
  margin-right: 1rem;
}

.sort-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

button[mat-stroked-button] {
  text-align: left;
  font-weight: 500;
  border-radius: 8px;
}

mat-menu button[mat-menu-item] mat-icon {
  margin-right: 8px;
}

.excelButton button[mat-raised-button] {
  height: 30px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #217346;
}

.excelButton mat-icon {
  font-size: 18px;
  vertical-align: middle;
  line-height: 1;
}

::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb {
  background-color: #5365c5;
}

::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-bar {
  background-color: #7f90f3;
}

::ng-deep .mat-slide-toggle .mat-slide-toggle-bar {
  background-color: #ccc;
}

::ng-deep .mat-slide-toggle .mat-ripple {
  display: none !important;
}

::ng-deep .age-pill.mat-slide-toggle {
  border-radius: 8px;
  padding: 0 12px;
  height: 36px;
  width: -moz-fit-content !important;
  width: fit-content !important;
}
::ng-deep .age-pill.mat-slide-toggle .mat-slide-toggle-content {
  font-size: 14px;
  white-space: nowrap;
}
::ng-deep .age-pill.mat-slide-toggle .mat-slide-toggle-label {
  gap: 8px;
  align-items: center !important;
  margin-top: 8px;
}
::ng-deep .age-pill.mat-slide-toggle .mat-slide-toggle-bar {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/user-list/user-list.component.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAA;EAEA,+BAAA;EACA,2BAAA;AADF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AAFF;;AAKA;EACE,gBAAA;EACA,WAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,eAAA;AAPF;;AAUA;EACE,oBAAA;AAPF;;AAUA;EAEE,eAAA;AARF;;AAWA;EACE,0CAAA;EACA,eAAA;EACA,kBAAA;AARF;;AAWA;EAEE,gCAAA;AATF;;AAYA;EACE,oBAAA;EACA,uBAAA;AATF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AATF;;AAYA;EACE,cAAA;AATF;;AAYA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AATF;;AAaA;EACE,oCAAA;EAEA,sCAAA;AAXF;;AAeA;EACE,cAAA;AAZF;;AAiBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAdF;AAiBE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,2BAAA;AAfJ;AAkBE;EACE,UAAA;AAhBJ;AAmBE;EACE,oCAAA;EACA,uBAAA;AAjBJ;;AAqBA;EACE,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAlBF;;AAsBA;EACE,+BAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAnBF;;AAyBA,2HAAA;AACA;EACE,kBAAA;AAtBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAzBF;;AA4BA;EACE,eAAA;EAIA,sBAAA;EACA,cAAA;AA5BF;;AAiCA;EACE,yBAAA;AA9BF;;AAiCA;EACE,yBAAA;AA9BF;;AAkCA;EACE,sBAAA;AA/BF;;AAmCA;EACE,wBAAA;AAhCF;;AAoCA;EAEE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kCAAA;EAAA,6BAAA;AAlCF;AAoCE;EACE,eAAA;EACA,mBAAA;AAlCJ;AAuCE;EACE,QAAA;EACA,8BAAA;EACA,eAAA;AArCJ;AAyCE;EACE,SAAA;AAvCJ","sourcesContent":[".min-height-vh-triggered {\r\n  // height: calc(100vh - 110px - 0.25rem);\r\n  min-height: 800px;\r\n  // max-height: calc(100vh - 110px - 0.25rem);\r\n  max-height: calc(100vh - 110px);\r\n  height: calc(100vh - 110px);\r\n\r\n}\r\n\r\n.table_list {\r\n  transition: 0.3s;\r\n}\r\n\r\n.registered_slider {\r\n  letter-spacing: .2px;\r\n  margin-bottom: 1rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.table-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-grow: 1;\r\n  width: 100%;\r\n}\r\n\r\n.table-responsive {\r\n  overflow-x: auto;\r\n  width: 100%;\r\n}\r\n\r\n.table {\r\n  margin-bottom: 0;\r\n  // font-family:inherit;\r\n}\r\n\r\n//   .mat-cell {\r\n//     // font-size: 12px;\r\n//   }\r\n\r\n.table th {\r\n  padding: .5rem;\r\n  font-weight: 600;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.table td {\r\n  vertical-align: middle;\r\n  padding: .5rem\r\n}\r\n\r\n.table td mat-checkbox label {\r\n  margin: 0 !important\r\n}\r\n\r\ntr.mat-mdc-row {\r\n  // height: 47px;\r\n  cursor: pointer;\r\n}\r\n\r\ntr.mat-mdc-row.highlighted {\r\n  background-color: rgba(159, 170, 229, 0.5);\r\n  margin: 0 -15px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.status-info-container {\r\n\r\n  text-shadow: 2px 2px 5px #b5b5b5;\r\n}\r\n\r\n.status-cell {\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.status-content {\r\n  display: inline-flex;\r\n  align-items: center; // 🔑 ευθυγράμμιση με το ΑΝΕΝΕΡΓΟΣ\r\n  gap: 4px;\r\n}\r\n\r\n.status-text {\r\n  line-height: 1;\r\n}\r\n\r\n.info-icon {\r\n  font-size: 18px;\r\n  height: 18px;\r\n  width: 18px;\r\n  line-height: 18px;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.excelButton button[mat-raised-button]:hover {\r\n  background-color: #408f64 !important;\r\n\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n\r\n.delete-btn-color {\r\n  color: #A72925;\r\n  // background-color: #A72925;\r\n\r\n}\r\n\r\n.chips-container {\r\n  display: flex;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.custom-chip {\r\n  position: relative;\r\n  background-color: #f5f5f5 !important;\r\n  border-radius: 4px !important;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n\r\n  // smooth blue underline on hover\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    left: 50%;\r\n    bottom: 0;\r\n    width: 0%;\r\n    height: 2px;\r\n    background-color: #3f51b5;\r\n    transition: all 0.3s ease;\r\n    transform: translateX(-50%);\r\n  }\r\n\r\n  &:hover::after {\r\n    width: 99%;\r\n  }\r\n\r\n  &.mdc-evolution-chip--selected {\r\n    background-color: #3f51b5 !important;\r\n    color: white !important;\r\n  }\r\n}\r\n\r\n.age-pill {\r\n  background: rgba(0, 0, 0, 0.04);\r\n  border-radius: 30px;\r\n  padding: 6px 14px;\r\n  font-size: 14px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  transition: background 0.2s ease;\r\n  margin-bottom: 18px;\r\n  transform: translateY(2px);\r\n  margin-right: 1rem;\r\n\r\n}\r\n\r\n.age-pill:hover {\r\n  background: rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.age-pill-input {\r\n  width: 50px;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  text-align: center;\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version.*/\r\nmat-chip-listbox {\r\n  margin-right: 1rem;\r\n\r\n}\r\n\r\n\r\n\r\n.sort-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\nbutton[mat-stroked-button] {\r\n  text-align: left;\r\n  font-weight: 500;\r\n  border-radius: 8px;\r\n}\r\n\r\nmat-menu button[mat-menu-item] mat-icon {\r\n  margin-right: 8px;\r\n}\r\n\r\n.excelButton button[mat-raised-button] {\r\n  height: 30px;\r\n  padding: 0 20px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border-radius: 8px;\r\n  line-height: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #217346;\r\n}\r\n\r\n.excelButton mat-icon {\r\n  font-size: 18px;\r\n\r\n\r\n\r\n  vertical-align: middle;\r\n  line-height: 1;\r\n}\r\n\r\n\r\n\r\n::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-thumb {\r\n  background-color: #5365c5;\r\n}\r\n\r\n::ng-deep .mat-slide-toggle.mat-checked .mat-slide-toggle-bar {\r\n  background-color: #7f90f3;\r\n}\r\n\r\n\r\n::ng-deep .mat-slide-toggle .mat-slide-toggle-bar {\r\n  background-color: #ccc;\r\n}\r\n\r\n\r\n::ng-deep .mat-slide-toggle .mat-ripple {\r\n  display: none !important;\r\n}\r\n\r\n\r\n::ng-deep .age-pill.mat-slide-toggle {\r\n  \r\n  border-radius: 8px; \r\n  padding: 0 12px;\r\n  height: 36px;\r\n  width: fit-content !important; \r\n\r\n  .mat-slide-toggle-content {\r\n    font-size: 14px; \r\n    white-space: nowrap;\r\n    \r\n  }\r\n\r\n  \r\n  .mat-slide-toggle-label {\r\n    gap: 8px;\r\n    align-items: center !important;\r\n    margin-top:8px;\r\n    \r\n  }\r\n\r\n  .mat-slide-toggle-bar {\r\n    margin: 0; \r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
